export default function Logo({ className = '', size = 64 }) {
  return (
    <svg
      viewBox="0 0 280 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ height: size, width: 'auto' }}
      data-testid="logo-svg"
    >
      {/* House outline */}
      <path
        d="M18 118 L140 22 L262 118 L262 262 L18 262 Z"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinejoin="miter"
        fill="none"
      />
      {/* THE */}
      <text
        x="140"
        y="170"
        textAnchor="middle"
        fontFamily="'Outfit', sans-serif"
        fontWeight="900"
        fontSize="46"
        fill="currentColor"
        letterSpacing="-1"
      >
        THE
      </text>
      {/* RELATIVE */}
      <text
        x="140"
        y="214"
        textAnchor="middle"
        fontFamily="'Outfit', sans-serif"
        fontWeight="900"
        fontSize="46"
        fill="currentColor"
        letterSpacing="-1"
      >
        RELATIVE
      </text>
      {/* GALLERY */}
      <text
        x="140"
        y="256"
        textAnchor="middle"
        fontFamily="'Outfit', sans-serif"
        fontWeight="900"
        fontSize="46"
        fill="currentColor"
        letterSpacing="-1"
      >
        GALLERY
      </text>
    </svg>
  );
}
